var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{ref:"dociframe",staticStyle:{"border":"none","height":"0px","width":"0px","display":"block"},attrs:{"width":"0","height":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }